import styled from 'styled-components';
import ArrowD from '../../assets/onboarding/arrow-down.svg';

const ArrowBlue = styled(ArrowD as React.SFC<React.SVGProps<SVGSVGElement>>)`

width: ${props => props.width || '1.1rem'};
height: ${props => props.height || '1.1rem'};
fill: ${props => props.fill || props.theme.colors.black.base};
display: ${props => props.display || 'flex'};
`;

export default ArrowBlue;
